import axios from 'axios';

export default function setup() {
  axios.interceptors.request.use(function(config) {

    const isLocalApi = ["localhost", "127.0.0.1"].includes( new URL(config.url).hostname );
    if (isLocalApi) { return config; }

    const userAccessToken = window.localStorage.getItem('access_token')
    const token = userAccessToken? userAccessToken.replace(/"/g, '') : false;

    if(token) {
      // delete config.headers.requestfrom;
      // delete config.headers.token;

      (config.headers.Authorization) ? config.headers.Authorization = `Bearer ${token}` : config.headers.authorization = `Bearer ${token}`;
    }
    return config;

  }, function(err) {

    console.log('interceptors err==', err);
    return Promise.reject(err);
  });
};



// WEBPACK FOOTER //
// ./src/helpers/interceptors.js